<ng-container *transloco="let t; prefix: 'collection-owner'">
  @let userCollection = collection();
  @if (accountService.currentUser()) {
    <div class="fw-light text-accent">
      {{t('collection-created-label', {owner: userCollection.owner})}}
      @if(userCollection.source !== ScrobbleProvider.Kavita) {
        {{t('collection-via-label')}}
        <app-image [imageUrl]="userCollection.source | providerImage"
                   width="16px" height="16px"
                   [ngbTooltip]="userCollection.source | scrobbleProviderName"
                   [attr.aria-label]="userCollection.source | scrobbleProviderName" />
      }
    </div>
  }
</ng-container>
